<input class="d-none" hidden #fileInput type="file" (change)="onFileChange($event); fileInput.value = null">
<div
  class="whc-form-field cursor-pointer w-100 d-flex justify-content-start align-items-center"
  [class.field-disabled]="control.disabled">
    <input type="text" class="cursor-pointer" readonly [placeholder]="placeholder | translate"
      [formControl]="fileNameControl" (click)="control.markAsTouched(); fileInput.click()">
</div>
